import { defineMessages } from 'react-intl';

const _default_1: {
	tryChat: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismissOnboarding: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	onboardingHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	onboardingDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	tryChat: {
		id: 'rovo-onboarding-try-chat',
		defaultMessage: 'Try Max',
		description:
			"Button label displayed on the primary action button in the Rovo onboarding spotlight within the AI conversation interface. Shown as the text on a button in the spotlight. When clicked, it starts a new chat session and begins the user's first interaction with the AI assistant. The purpose is to provide a clear call-to-action for users to begin using the AI chat feature after viewing the onboarding information.",
	},
	dismissOnboarding: {
		id: 'rovo-onboarding-dismiss',
		defaultMessage: 'Dismiss',
		description:
			'Button label displayed on the dismiss button in the Rovo onboarding spotlight within the AI conversation interface. Shown as the text on a button in the spotlight. When clicked, it closes the onboarding spotlight without starting a chat. The purpose is to provide users with a way to skip the onboarding if they are already familiar with the feature or want to explore on their own.',
	},
	onboardingHeading: {
		id: 'rovo-onboarding-heading',
		defaultMessage: 'Say hi to Max',
		description:
			'Heading text displayed at the top of the Rovo onboarding spotlight within the AI conversation interface. Shown as the main title or heading in the spotlight. The purpose is to immediately communicate to new users what the feature is about, which is chatting with an AI assistant to get help with work tasks.',
	},
	onboardingDescription: {
		id: 'rovo-onboarding-description',
		defaultMessage: 'Max takes on complex, multi-step work and comes back with a finished result.',
		description:
			'Description text displayed in the body of the Rovo onboarding spotlight within the AI conversation interface. Shown as the body text below the heading. The purpose is to explain the key capabilities of Rovo Chat: exploring company knowledge, creating content, and collaborating on work, helping users understand the value and use cases for the AI assistant.',
	},
});
export default _default_1;
